import React, { Ref } from "react";
import { Controller, Control } from "react-hook-form";
import MarkDownEditor from "../../markdownEditor/MarkdownEditor";
import Label from "components/shared/form/Label";
import { omit } from "lodash";
import Hint from "components/shared/fields/Hint";

type TextFieldArgs = {
  name: string;
  control?: Control<any>;
  label?: string;
  required?: boolean;
  enableTixxtMentions?: boolean;
  placeholder?: string;
  textEditorRef?: Ref<HTMLDivElement>;
  hint?: string;
};
export default function TextEditor({
  name,
  control,
  label,
  enableTixxtMentions,
  placeholder = "",
  required = false,
  textEditorRef,
  hint,
}: TextFieldArgs) {
  return (
    <div className="control-group">
      {label && <Label label={label} required={required} />}
      <div ref={textEditorRef} className="controls">
        <Controller
          name={name}
          control={control}
          rules={{
            required,
          }}
          render={({ field }) => (
            <div className="h-48">
              <MarkDownEditor
                enableTixxtMentions={enableTixxtMentions}
                {...omit(field, ["ref"])}
                placeholder={placeholder}
              />
            </div>
          )}
        />
        {hint && <Hint hint={hint} />}
      </div>
    </div>
  );
}
